
/*
 *  This file server-error-handler.service.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */

import { Injectable, signal } from '@angular/core';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { LogErrorsService } from './log-errors';
import { SnackbarAlertService } from '../snackbar-alert.service';
import { ConfigurationService } from '../configuration.service';

@Injectable()
export class ServerErrorHandler {
    showAnaltyicsDashboard = false;
    confirmDialog = {
        show: false
    };
    refreshMenuSignal = signal<boolean | null>(null);
    isRefreshMenu!: boolean;
    constructor(
        private readonly _logError: LogErrorsService,
        private readonly _snackBar: SnackbarAlertService,
        public _config: ConfigurationService,
        private readonly _httpClient: HttpClient,
    ) {

    }

    handleServerError(err: HttpErrorResponse, isUnauthorize?: string | undefined) {
        const isLogin = localStorage.getItem('authlogin');
        if (navigator.onLine) {
            this._logError.logError(err);
            if (isLogin || isUnauthorize) {
                if (err instanceof HttpErrorResponse) { // Changed by shaily after discussion with Raju sir
                    if (err.status === 0) {
                        this._snackBar.Alert('You are in low internet bandwidth. Please check and try again', '2');
                        // Changed message by Shaily after discussion with Raju sir
                    } else if (err.status !== 306) {
                        if (err.error && err.error.message && err.error.validationType && err.error.validationType == '3') {
                            this._snackBar.Alert(err.error.message, '3');
                        } else if (err.error && err.error.message) {
                            this._snackBar.Alert(err.error.message, '2');
                        } else if (err.error && err.error.error_description) {
                            this._snackBar.Alert(err.error.error_description, '2');
                        } else if (err.error && err.error.error) {
                            if (err.error.error != 'invalid_grant') {
                                this._snackBar.Alert(err.error.error, '2');
                            }
                        } else if (typeof err.error === 'string') {
                            if (!(this.showAnaltyicsDashboard)) {
                                this._snackBar.Alert(err.error, '2');
                            }
                        } else {
                            this._snackBar.Alert('An error occurred: ' + err.name, '2');
                        }
                    }

                } else {
                    if ((err as any).status === 5999) {
                        console.log({ err })
                    }
                    else {
                        this._snackBar.Alert(`Unknown error`, '2');
                    }
                }
            }
        } else {
            this._snackBar.Alert(`Please check your internet connection`, '2');
        }

        return throwError(err);
    }
}